<template>
  <div id="messageNoticeList" v-if="messageNotice.selectAuth">
    <el-form ref="searchForm" :model="searchForm" size="mini" :inline="true" :label-position="position">
      <el-form-item>
        <el-input v-model="searchForm.createUserName" placeholder="发布者"></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker type="datetime" v-model="searchForm.noticeTime" placeholder="发布时间"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="searchSubmit">查询</el-button>
        <el-button type="primary" @click="showAdd">新增</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="2">
      <el-col :xs="10">
        <el-table :data="messageNoticeList" style="width: 100%;" border :fit="true"
                  :header-cell-style="{'text-align':'center'}">
          <el-table-column prop="createUserName" label="发布者" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" :formatter="resolvingDate" sortable resizable
                           :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="title" label="标题" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="memo" label="备注" sortable resizable :show-overflow-tooltip="true"
                           align="center"></el-table-column>
          <el-table-column prop="isNew" label="是否为最新" sortable resizable :show-overflow-tooltip="true"
                           align="center">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.isNew === 1 ? 'success' : 'danger'"
                disable-transitions>{{scope.row.isNew==1?'是':'否'}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" sortable resizable :show-overflow-tooltip="true"
                           align="center">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleCopy(scope.$index, scope.row)" >复制</el-button>
              <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" v-show="scope.row.isNew==1" type="info"
                         @click="handleClose(scope.$index, scope.row)">关闭
              </el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination align='left'
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pages.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="pages.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pages.total">
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="公告信息" :visible.sync="dialogFormVisible" center>
      <el-form :model="messageNoticeInfo" required-asterisk label-width="auto" :label-position="position" center>
        <el-form-item required  label="标题">
          <el-input v-model="messageNoticeInfo.title" clearable></el-input>
        </el-form-item>
        <el-form-item label="标签">
          <el-input v-model="messageNoticeInfo.tag" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="messageNoticeInfo.memo"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch
            v-model="messageNoticeInfo.isNew"
            active-color="#13ce66"
            inactive-color="#909399">
          </el-switch>
        </el-form-item>
        <el-form-item label="发布者">
          <el-input v-model="messageNoticeInfo.createUserName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item required label="发布时间">
          <el-date-picker required  type="datetime" v-model="messageNoticeInfo.noticeTime" style="width: 100%"
                          placeholder="发布时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="内容">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入内容"
            v-model="messageNoticeInfo.content">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">发布</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {insertNotice, removeNotice, selectNoticeAll, selectNoticeInfo, updateNotice} from '../../api/api';
  import {getPermission} from '../../api/authRequest';
  import {hideLoading, showLoading} from "../../components/loading/loading";

  export default {
    data() {
      return {
        messageNotice: {
          selectAuth: false
        },
        searchForm: {
          createUserName: '',
          noticeTime: '',

        },
        position: 'left',
        messageNoticeList: [],
        pages: {
          page: 1,
          pageSize: 10,
          total: 0

        },
        messageNoticeInfo: {},
        dialogFormVisible: false,
        isAdd: false,
      }
    },
    created() {

    },
    mounted() {
      this.messageNotice.selectAuth = getPermission("/system/messageNotice/getAll");
      this.getNoticeAll();
    },
    methods: {
      searchSubmit() {
        let _self = this;
        _self.getNoticeAll();
      },
      //获取列表
      getNoticeAll() {
        let _self = this;
        let params = {
          createUserName: _self.searchForm.createUserName,
          noticeTime: _self.searchForm.noticeTime,
          pageSize: _self.pages.pageSize,
          startRow: _self.pages.page,
        }
        selectNoticeAll(params).then(response => {
          if (response.data.status == 100) {
            this.messageNoticeList = response.data.results.list;
            this.pages.total = response.data.results.total;
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //获取详情
      getInfo(id) {
        let _self = this;
        if (!id) {
          this.$message({
            message: "id is null",
            type: "error"
          });
          return;
        }
        let params = {
          id: id
        };
        selectNoticeInfo(params).then(response => {
          if (response.data.status == 100) {
            let result = response.data.results;
            _self.messageNoticeInfo = result;
            _self.messageNoticeInfo.isNew = result.isNew == 1;
            _self.dialogFormVisible = true;
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      handleSizeChange(val) {
        this.pages.pageSize = val
        this.selectNoticeAll()
      },
      handleCurrentChange(Page) {
        this.pages.page = Page
        this.selectNoticeAll()
      },
      //复制
      handleCopy(index,row){
        let _self=this;
        _self.messageNoticeInfo.title=row.title;
        _self.messageNoticeInfo.tag=row.tag;
        _self.messageNoticeInfo.memo=row.memo;
        _self.messageNoticeInfo.isNew=row.isNew==1?true:false;
        _self.messageNoticeInfo.content=row.content;
        _self.dialogFormVisible=true;
        _self.isAdd=true;
      },
      //修改
      handleEdit(index, row) {
        let _self = this;
        _self.getInfo(row.id);
        _self.isAdd = false;
      },
      //删除
      handleDelete(index, row) {
        let _self = this;
        _self.remove(row.id);
      },
      //关闭
      handleClose(index, row) {
        let _self = this;
        _self.close(row.id)
      },
      //发布
      submit() {
        let _self = this;
        if (!_self.messageNoticeInfo.title){
          this.$message({
            message: "标题为空",
            type: "error"
          });
          return;
        }
        if (!_self.messageNoticeInfo.noticeTime){
          this.$message({
            message: "发布时间为空",
            type: "error"
          });
          return;
        }
        if (new Date(_self.messageNoticeInfo.noticeTime).getTime()<new Date().getTime()){
          this.$message({
            message: "发布时间不能小于当前时间",
            type: "error"
          });
          return;
        }
        let params = {
          id: _self.messageNoticeInfo.id,
          title: _self.messageNoticeInfo.title,
          tag: _self.messageNoticeInfo.tag,
          memo: _self.messageNoticeInfo.memo,
          content: _self.messageNoticeInfo.content,
          noticeTime: _self.messageNoticeInfo.noticeTime,
          isNew:_self.messageNoticeInfo.isNew?1:0,
        };
        showLoading();
        if (_self.isAdd) {
          insertNotice(params).then(response => {
            hideLoading()
            if (response.data.status == 100) {
              _self.dialogFormVisible = false;
              _self.getNoticeAll();
            } else {
              this.$message({
                message: response.data.message,
                type: "error"
              });
            }
          }).catch((error) => {
            this.$Message.error(error.message);
          })
        } else {
          updateNotice(params).then(response => {
            hideLoading()
            if (response.data.status == 100) {
              _self.dialogFormVisible = false;
              _self.getNoticeAll();

            } else {
              this.$message({
                message: response.data.message,
                type: "error"
              });
            }
          }).catch((error) => {
            this.$Message.error(error.message);
          })
        }

      },
      //新增
      showAdd() {
        let _self = this;
        _self.messageNoticeInfo = {};
        _self.dialogFormVisible = true;
        _self.isAdd = true;
      },
      //删除
      remove(id) {
        let _self = this;
        if (!id) {
          this.$message({
            message: "id is null",
            type: "error"
          });
          return;
        }
        let params = {
          id: id
        };
        showLoading();
        removeNotice(params).then(response => {
          hideLoading();
          if (response.data.status == 100) {
            _self.dialogFormVisible = false;
            _self.getNoticeAll();

          } else {
            this.$message({
              message: response.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //关闭
      close(id) {
        let _self = this;
        if (!id) {
          this.$message({
            message: "id is null",
            type: "error"
          });
          return;
        }
        let params = {
          id: id,
          isNew: 0
        };
        showLoading();
        updateNotice(params).then(response => {
          hideLoading();
          if (response.data.status == 100) {
            _self.dialogFormVisible = false;
            _self.getNoticeAll();

          } else {
            this.$message({
              message: response.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      /*时间格式化*/
      resolvingDate: function (row, column) {
        if (!row.createTime) {
          return "";
        }
        let d = new Date(row.createTime);
        let month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
        let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();

        let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    },
  }
</script>

<style type="text/css" lang="scss" scoped>
  #messageNoticeList {
    .box-card {
      margin-bottom: 20px;
      border-radius: 0px;

      /*.header{background-color: #f5f5f5}*/
      .card-header {
        font-size: 14px;
        line-height: 0px;
      }
    }

    font-size: 14px;

    .el-dialog__footer {
      text-align: center;
    }

    .headerT {
      font-size: 16px;
      margin: 0 0 15px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// messageNotice.vue?80421ebc